import { Reveal, Overline } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { GlobeHemisphereEast, Certificate, PenNib, Copyright, ChartLineUp, Briefcase, ArrowUpRight } from "@phosphor-icons/react";

const SERVICES = [
  {
    slug: "patents",
    icon: GlobeHemisphereEast,
    title: "Patents",
    body: "Complete patent lifecycle support across every technology domain — mechanical, electronics, software, telecom, chemistry, biotech, pharma and medical devices.",
    tags: ["Patentability & FTO Search", "Specification Drafting", "PCT & National Phase", "FER / Office Actions", "Opposition Support", "Renewals & Annuities"],
    large: true,
  },
  {
    slug: "trademarks",
    icon: Certificate,
    title: "Trademarks",
    body: "Word marks, logos, device and series marks — searched, filed, prosecuted and watched, with full representation before the trademark registry.",
    tags: ["Availability Search", "Filing & Registration", "Examination Response", "Hearings & Opposition", "Watch & Renewal", "Assignment & Licensing"],
    large: true,
  },
  { slug: "designs", icon: PenNib, title: "Designs", body: "Design search and novelty assessment, application drafting and filing, prosecution and renewal of registered designs." },
  { slug: "copyrights", icon: Copyright, title: "Copyrights", body: "Registration of literary, artistic, software, musical and cinematographic works — plus assignment, licensing and infringement support." },
  { slug: "patent-analytics", icon: ChartLineUp, title: "Patent Analytics", body: "Patentability, freedom-to-operate, landscape and invalidation studies, portfolio valuation, and competitor & technology watch." },
  { slug: "job-work", icon: Briefcase, title: "Job-Work Support", body: "Outsourced drafting, proofreading, formatting and figure preparation for law firms and corporate IP departments — project or retainer basis." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <Reveal>
          <Overline>Practice areas</Overline>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
            <h2 className="font-serif font-light tracking-tight text-4xl sm:text-5xl leading-tight max-w-xl">
              Every form of IP, <span className="italic text-gold">under one roof.</span>
            </h2>
            <p className="text-mist max-w-md text-base leading-relaxed">
              From search &amp; analytics to prosecution, enforcement and portfolio
              management — a single window for all IPR requirements, including dedicated
              job-work support for law firms and IP departments.
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06} className={s.large ? "" : ""}>
              <Link to={`/services/${s.slug}`} data-testid={`service-card-${i}`} className="block h-full">
                <div
                  className={`group relative h-full backdrop-blur-xl bg-navy-900/40 border border-gold/20 hover:border-gold/50 transition-colors duration-300 p-8 sm:p-10 shadow-[0_8px_32px_rgba(0,0,0,0.5)] ${s.large ? "min-h-[280px]" : ""}`}
                >
                  <s.icon size={36} weight="duotone" className="text-gold mb-6" />
                  <h3 className={`font-serif text-white ${s.large ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"} mb-4`}>{s.title}</h3>
                  <p className="text-mist text-sm sm:text-base leading-relaxed">{s.body}</p>
                  {s.tags && (
                    <div className="flex flex-wrap gap-2 mt-7">
                      {s.tags.map((t) => (
                        <span key={t} className="text-[11px] uppercase tracking-wider border border-gold/30 text-gold/90 px-3 py-1">
                          {t}
                        </span>
                      ))}
                    </div>
                  )}
                  <ArrowUpRight size={20} className="absolute top-8 right-8 text-gold/40 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
